export const ordenatePaymentsArray = (array) => {
    if (array?.length < 1) return
    return array?.sort((a, b) => {
      if (a.to < b.to) return 1
      if (a.to > b.to) return -1
      return 0
    })
  }